interface RawInputEditorProps {
  value: string;
  onChange: (v: string) => void;
  maxChars: number;
  disabled?: boolean;
}

export function RawInputEditor({
  value,
  onChange,
  maxChars,
  disabled = false,
}: RawInputEditorProps) {
  return (
    <div style={{ marginBottom: '4px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '6px',
      }}>
        <label style={{
          fontSize: '11px',
          fontWeight: 600,
          color: 'var(--text-muted)',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          fontFamily: "'Outfit', sans-serif",
        }}>
          Your draft
        </label>
        <span style={{
          fontSize: '12px',
          color: value.length > maxChars * 0.9 ? '#fca5a5' : 'var(--text-muted)',
        }}>
          {value.length.toLocaleString()} / {maxChars.toLocaleString()}
        </span>
      </div>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        placeholder="Paste your raw draft communication here..."
        style={{
          width: '100%',
          minHeight: '200px',
          padding: '14px 16px',
          border: '1px solid rgba(0,212,255,0.15)',
          borderRadius: '12px',
          background: 'var(--bg-elevated)',
          color: 'var(--text-primary)',
          fontSize: '14px',
          lineHeight: 1.7,
          resize: 'vertical',
          outline: 'none',
          transition: 'border-color 0.2s, box-shadow 0.2s',
          fontFamily: "'Inter', system-ui, sans-serif",
          opacity: disabled ? 0.5 : 1,
        }}
        onFocus={e => {
          e.target.style.borderColor = 'rgba(0,212,255,0.5)';
          e.target.style.boxShadow = '0 0 0 3px rgba(0,212,255,0.08)';
        }}
        onBlur={e => {
          e.target.style.borderColor = 'var(--border)';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  );
}
